import { Ng1StateDeclaration } from '@uirouter/angularjs';

const states: Ng1StateDeclaration[] = [
    {
        name: 'sso',
        url: '/sso',
        abstract: false,
        component: 'wtSingleSignOn',
        data: {
            visible: false,
            isAuthenticated: false,
            isConnected: false,
            icon: 'fa-sign-in',
            displayName: 'Single Sign On Login',
            editButtonVisibility: () => false
        }
    }];

export default states;